import zhLocale from "element-ui/lib/locale/lang/zh-CN";

export default {
  language: {
    zhName: "简体中文",
    enName: "English",
    zh: "ZH",
    en: "EN"
  },
  navbar: {
    flag: "zh",
    blockHeight: "区块高度",
    wallet: "钱包",
    blocks: "区块列表",
    addrs: "地址列表",
    tarns: "交易列表",
    ontIds: "ONT ID 列表",
    top: {
      blockchain: "区块链",
      contracts: "合约",
      tokens: "通证",
      ontId: "ONT ID",
      apis: "API文档",
      mainNet: "主网",
      testNet: "测试网",
      nodes: "节点",
      stake: "质押授权",
      nodeMap: "节点地图",
      blocks: "区块",
      txns: "交易",
      accounts: "账户",
      oep4: "OEP-4",
      oep5: "OEP-5",
      oep8: "OEP-8",
      submit: "提交",
      statistics: "统计",
      tool: "工具",
      apiDocUrl: "https://dev-docs.ont.io/#/docs-cn/explorer/overview"
    }
  },
  all: {
    more: ">>",
    name: "名称",
    return: "返回",
    block: "区块",
    hash: "哈希",
    status: "状态",
    time: "创建时间",
    height: "高度",
    byte: "字节",
    num: "数量",
    fee: "费用",
    amount: "总额",
    address: "地址",
    ontId: "ONT ID",
    content: "内容",
    confirmed: "已确认",
    failed: "失败",
    description: "描述信息",
    token: "通证",
    txn: "交易",
    txns: "交易",
    pk: "公钥",
    from: "转出地址",
    to: "转入地址",
    type: "类型",
    tokens: "资产列表",
    contract: "合约",
    nonce: "随机数",
    jsonopen: "展开",
    jsonclose: "收起",
    analytics: "分析",
    transfers: "转账",
    tokenid: "Token ID",
    maxMsg1: "总共找到 ",
    maxMsg2: " 条交易",
    maxMsg3: "(仅显示最后的 ",
    maxMsg4: " 条数据)",
    unknown: "未知",
    pending: "未确认",
    colon: "："
  },
  ontPagination: {
    total: "共有 ",
    data: " 条数据"
  },
  searchInput: {
    search: "查询",
    placeholder: "ONT ID、地址、交易哈希、通证、合约、区块高度",
    slogan: "区块链浏览器 & 可信验证器",
    qucik: "快速链接：",
    oep4: "OEP-4",
    contracts: "合约列表",
    token: "通证",
    ontId: "ONT ID",
    address: "地址",
    transaction: "交易哈希",
    blockHeight: "区块高度",
    contract: "合约"
  },
  runStatus: {
    name: "全网运行状态",
    RunningTime: "全网运行时间: ",
    CurrentHeight: "当前区块高度",
    BlockInterval: "平均出块时间",
    TxnCount: "当前交易笔数",
    NodeCount: "北斗节点数量",
    addressCount: "注册地址数量",
    second: "秒",
    address: "地址数",
    ontid: "ONT ID 总数",
    overview: "概览",
    ontprice: "ONT 价格($)",
    ongprice: "ONG 价格($)",
    rank: "市值排名",
    onttx: "30天 ONT 交易数",
    datacmc: "数据来自 CoinMarketCap",
    most: "本体用户都在用的官方钱包"
  },
  lastData: {
    lastdata: "最新数据",
    ontid: "最新ONT ID事件",
    tx: "最新交易",
    block: "最新区块"
  },
  ontIdList: {
    name: "最新 ONT ID 事件"
  },
  ontIdDetail: {
    nickname: "ONT ID 详情",
    name: "ONT ID: ",
    msgName: "ONT ID 事件记录",
    TxnId: "交易 id",
    Height: "区块高度",
    TxnType: "交易类型",
    TxnTime: "区块时间",
    Description: "操作描述",
    events: "在这个 ONT ID 上的事件",
    owner: "所属人",
    controller: "控制人",
    attributes: "属性",
    failed: "没有找到数据。"
  },
  blockList: {
    name: "最新区块",
    Height: "区块高度",
    TxnNum: "交易",
    bookkeeper: "记账人",
    BlockSize: "大小",
    BlockTime: "出块时间",
    bookkeeperCount: "记账人"
  },
  addressList: {
    rank: "排名",
    name: "地址",
    nickname: "持仓排名",
    balance: "余额",
    percent: "占比"
  },
  addressDetail: {
    name: "地址详情",
    address: "地址：",
    showRelatedAddress: "显示相关地址",
    hideRelatedAddress: "隐藏相关地址",
    relatedEVMAddress: "相关Ontology EVM地址",
    relatedOntologyAddress: "相关Ontology地址",
    relatedAddressTip: `
关于相关地址： <br/><br/>
1. 地址字节码相同； <br/>
2. 私钥/助记词等不同，且无法获取； <br/>
4. 原生ONG余额可共享； <br/>
5. 其它通证不共享。 <br/><br/>
请勿向相关地址转入ONG以外的任何通证，否则将无法转出。
`,
    ontBalance: "ONT",
    ongBalance: "ONG",
    claimable: "可提取的 ONG",
    unbound: "未解绑的 ONG",
    txOnAddr: "笔交易在这个地址上",
    txns: "交易列表",
    oep8Assets: "OEP-8 资产",
    oep4Assets: "OEP-4 资产",
    oep5Assets: "OEP-5 资产",
    orc20Assets: "ORC-20 资产",
    orc721Assets: "ORC-721 资产",
    orc1155Assets: "ORC-1155 资产",
    oepOtherAssets: "其他的 OEP 资产"
  },
  analytics: {
    ontBalance: "ONT 余额",
    ongBalance: "ONG 余额",
    tx: "交易",
    token: "通证转账",
    transferAmount: "交易数额",
    transferCount: "交易总数",
    uniqueReceiver: "去重转入地址数",
    uniqueSender: "去重转出地址数",
    totalUnique: "去重地址数",
    balance: "余额",
    txnCount: "交易总数",
    uniqueOutAddress: "去重转出地址数",
    uniqueinAddress: "去重转入地址数",
    tokenTransfer: "Token Transfers",
    tokenContracts: "Token Contracts Count",
    contracts: "合约调用数量",
    outboundTransfers: "转出交易数",
    InboundTransfers: "转入交易数",
    uniqueAddresssent: "Unique Address Sent",
    uniqueAddressreceived: "Unique Address Received",
    uniqueAddress: "去重地址数",
    tokenTransfer: "Token Transfers",
    addressCount: "地址数",
    nodata: "暂无数据"
  },
  top: {
    title: "最佳统计数据",
    overview: "概况",
    ontTx: "ONT 交易",
    ongTx: "ONG 交易",
    tokens: "通证",
    network: "网络",
    day: "24 小时",
    days: "3 天",
    week: "7 天",
    ten: "查看前十",
    ontsender: "发出 ONT 数量最多的地址",
    ontreceiver: "收到 ONT 数量最多的地址",
    ontcountsender: "发出 ONT 交易最多的地址",
    ontcountreceiver: "收到 ONT 交易最多的地址",
    ongsender: "发出 ONG 数量最多的地址",
    ongreceiver: "收到 ONG 数量最多的地址",
    ongcountsender: "发出 ONG 交易最多的地址",
    ongcountreceiver: "收到 ONG 交易最多的地址",
    topsendertokens: "去重发送地址数排名",
    topreceivertokens: "去重接收地址数排名",
    topaddresstokens: "去重交易地址数排名",
    toptxtokens: "交易数排名",
    topsendertoken: "去重发送地址数排名",
    topreceivertoken: "去重接收地址数排名",
    topaddresstoken: "去重交易地址数排名",
    toptxtoken: "交易数排名",
    topgasaddresses: "消耗最多手续费的地址",
    toptxaddresses: "发生交易最多的地址",
    topgasaddress: "消耗最多手续费的地址",
    toptxaddress: "发生交易最多的地址",
    rank: "排名",
    address: "地址",
    gasused: "手续费消耗",
    txcount: "交易数",
    tokename: "通证名称",
    uniquesender: "去重发送地址数",
    uniquereceiver: "去重接收地址数",
    uniquetotal: "去重总地址数",
    percentage: "占比",
    ontamount: "ONT 总数",
    ongamount: "ONG 总数",
    totalTx: "交易数",
    total: "总数"
  },
  assetName: {
    ont: "ONT",
    ong: "ONG",
    pumpkin01: "红南瓜",
    pumpkin02: "橘南瓜",
    pumpkin03: "黄南瓜",
    pumpkin04: "绿南瓜",
    pumpkin05: "靛南瓜",
    pumpkin06: "蓝南瓜",
    pumpkin07: "紫南瓜",
    pumpkin08: "金南瓜"
  },
  blockDetail: {
    nickname: "区块详情",
    name: "区块高度：",
    BlockSize: "区块大小",
    BlockTime: "生成时间",
    keeper: "记账人地址",
    hash: "哈希值",
    TxnNum: "区块内交易笔数：",
    Hash: "当前区块哈希：",
    PrevBlock: "上一个区块：",
    LastBlock: "最后一个区块：",
    NextBlock: "下一个区块：",
    merkle: "交易根",
    Consensus: "共识数据",
    txOnBlock: "条交易记录在这个区块"
  },
  transList: {
    name: "最新交易",
    hash: "交易哈希",
    total: "总共",
    data: "条交易",
    confirmed: "已确认",
    failed: "失败",
    txType01: "部署合约交易",
    txType02: "OEP-4 交易",
    txType03: "OEP-5 交易",
    txType04: "OEP-8 交易",
    txType05: "调用合约交易",
    txType06: "ONT-ID 交易",
    txType07: "ONT 转账交易",
    txType08: "ONG 转账交易",
    txType09: "ORC-20 交易",
    txType10: "ORC-721 交易",
    txType11: "ORC-1155 交易"
  },
  txDetail: {
    name: "交易详情",
    txHash: "哈希：",
    time: "时间：",
    type: "类型",
    deploySC: "Deploy Smart Contract",
    sc: "Invoke NeoVM Contract",
    wasmsc: "Invoke WasmVM Contract",
    evm: "Invoke EVM Contract",
    height: "高度",
    status: "状态",
    fee: "费用",
    issuer: "发行人  ONT ID",
    detial: "合约事件",
    open: "详情",
    close: "收起",
    transactionHex: "交易 Hex",
    transactionJson: "交易 Json",
    hexopen: "Hex",
    jasoopen: "Json",
    transfersOnTx: "该交易内的转账",
    noTxn: "未查询到该交易哈希",
    noTxnP1: "如果交易刚刚创建，请等待几秒后再刷新此页面。",
    noTxnP2: "如果一段时间后仍未查询到此交易，请与交易发送方确认。",
    inputData: {
      title: "数据输入",
      viewType: "查看方式",
      defaultView: "默认",
      originalView: "原始",
      utf8View: "UTF-8",
      decode: "解码输入数据",
      switchBack: "切换回",
      name: "名称",
      type: "类型",
      data: "数据"
    }
  },
  claimDetail: {
    name: "认证详情"
  },
  addressMsg: {
    name: "地址信息",
    address: "地址",
    latestDealTime: "最新交易时间",
    dealNumber: "交易次数",
    addressGenerationTime: "地址生成时间",
    balance: "余额"
  },
  page: {
    First: "首页",
    PreviousPage: "上一页",
    NextPage: "下一页",
    Last: "末页"
  },
  nodes: {
    stakeListTit: "质押授权",
    rank: "排名",
    name: "名称",
    proportion: "下一轮节点/用户的奖励比例",
    reward: "奖励",
    stake: "质押",
    process: "进度",
    toNextRound: "到下一轮： ",
    blocks: "块",
    detailTit: "节点详情",
    nodeName: "节点名称： ",
    ontId: "ONT ID：",
    address: "地址：",
    rewardRate: "奖励比例：",
    rank2: "排名：",
    stake2: "质押：",
    stakeOWallet: "在 Owallet 上质押 →",
    process2: "进度：",
    ip: "IP地址：",
    email: "邮箱：",
    intro: "介绍：",
    vision: "愿景：",
    website: "官网：",
    guideTxt: "要参与质押授权，请找到分步指南：",
    here: "点击这里。",
    tooltipTit:
      "这是在下一轮共识中，节点选择与他们授权质押的用户，共享的奖励部分。",
    processTip: "正在计算实时数据中。 请等待一会： "
  },
  contracts: {
    list: {
      name: "合约",
      tit: {
        currently: "当前共有",
        contracts: "条合约",
        checkIn: "申请录入"
      },
      tab: {
        hash: "合约哈希",
        name: "合约名称",
        time: "创建时间",
        txns: "交易数量",
        desc: "合约描述",
        logo: "Logo",
        addressCount: "交易地址数",
        address: "地址"
      }
    },
    detail: {
      name: "合约详情页",
      hash: "哈希",
      address: "地址",
      overview: "合约概览",
      desc: "合约描述",
      txOn: "条交易记录在这个合约：",
      creator: "创建者",
      createdTime: "创建时间",
      contractInfo: "信息",
      logo: "Logo",
      ontFlow: "ONT 流水总量：",
      ongFlow: "ONG 流水总量：",
      amount: "流水总量：",
      contact: "联系方式",
      compilerType: "编译器类型",
      compilerVersion: "编译器版本",
      optimizationEnabled: "优化开启",
      OptimizationOn: "是，{runs} runs",
      OptimizationOff: "否，{runs} runs",
      otherSettings: "其他设置",
      contractSourceCodeFile: "文件{index}/{length}：",
      settings: "设置",
      constructorArgument: "构造函数参数",
      contractSourceCode: "合约代码",
      virtualMachine: "虚拟机",
      website: "网站：",
      email: "邮箱：",
      "Official Website": "网站：",
      otherSettingsContent: `
      EVM版本：{version}<br/><br/>
      许可类型设置：{license}
 `,
    },
    submit: {
      headline: "提交合约",
      form: {
        vm_type: "虚拟机",
        contract_hash: "合约地址",
        description: "合约描述（可选）",
        compiler_type: "编译器类型",
        compiler_version: "编译器版本",
        optimization: "优化开启",
        optimization_on: "是",
        optimization_off: "否",
        constructor_argument: "构造函数参数（ABI编码，十六进制字符串，可选）",
        constructor_argument_short: "构造函数参数",
        library_list: "合约库（Library）地址（可选，最多10个）",
        library_name: "Library_{index} 名称",
        library_address: "Library_{index} 合约地址",
        library_format: "Library_{index}",
        misc_settings: "其他设置",
        runs: "Runs（优化器）",
        runs_short: "Runs",
        evm_version: "EVM版本",
        license_type: "许可类型设置",
        source_code: "合约源码",
        abi: "合约ABI",
        byte_code: "合约字节码",
        upload_text: "点击上传合约源码",
        required: "请输入{field}",
        invalid:  "{field}格式不正确",
        success: "提交成功"
      },
      submitted: {
        title: '已提交',
        info: "合约信息已提交，正在验证中。验证时间预计几分钟。如果验证成功，合约将显示在合约列表中。如果未显示则说明验证失败，即提交的信息与部署在链上的合约信息不完全一致，请重新提交准确的信息。"
      },
      multiFileTip: `
      目前只支持验证同一目录下的多文件。
    `,
    }
  },
  tokens: {
    list: {
      name: "通证列表",
      tab: {
        hash: "合约哈希",
        name: "合约名称",
        time: "创建时间",
        txns: "交易数量",
        desc: "合约描述",
        logo: "Logo",
        symbol: "通证",
        creator: "创建者",
        totalSupply: "总量",
        decimals: "精度",
        addressCount: "持有地址数",
        vm_category: "虚拟机类型",
        address: "地址"
      },
      type: "{type} 通证"
    },
    detail: {
      vm_category: "虚拟机类型",
      name: "通证详情页",
      hash: "哈希",
      address: "地址",
      overview: "合约概览",
      desc: "合约描述",
      txOn: "条交易记录在这个合约：",
      creator: "创建者",
      createdTime: "创建时间",
      contractInfo: "信息",
      logo: "Logo",
      ontFlow: "ONT 流水总量：",
      ongFlow: "ONG 流水总量：",
      amount: "流水总量：",
      txn: "交易总数",
      volume: "流水总量",
      code: "字节代码",
      abi: "ABI",
      totalSupply: "发行总量",
      decimals: "精度位数",
      statistic: "数据统计",
      tokenLbl: "通证标签",
      tokenImg: "通证图片",
      holder: "持有人",
      tip: "注意：该项为累积统计，可能有最多10分钟的统计差异。",
      price: "价格",
      tokenOverview: "概况",
      tokenProfile: "资料概要"
    },
    submit: {
      headline: "提交通证信息",
      separator: "",
      form: {
        hash: "通证哈希",
        name: "通证名称",
        VM: "虚拟机类型",
        ABI: "通证ABI",
        code: "通证代码",
        description: "通证描述",
        symbol: "通证简称",
        decimals: "通证精度",
        totalSupply: "总发行量",
        logoTip: "256*256像素，JPG或PNG格式，无圆角",
        contactInformation: "联系方式",
        website: "网站（可选）",
        email: "邮箱地址",
        ID: "通证ID",
        operation: "操作",
        noAdded: "未添加通证",
        add: "添加",
        succ: "通证信息提交成功"
      }
    }
  },
  statistics: {
    name: "历史统计",
    day: "天",
    newAddressLbl: "新增地址数",
    activeAddressLbl: "活动地址数",
    blockLbl: "新增区块数",
    newOntIdLbl: "新增 ONT ID 数",
    activeOntIdLbl: "活动 ONT ID 数",
    sumAddressLbl: "地址增长",
    sumOntIdLbl: "ONT ID 增长",
    txnLbl: "交易数",
    ontLbl: "ONT 交易总额",
    ongLbl: "ONG 交易总额"
  },
  footer: {
    flag: "zh",
    Development: "开发",
    DeveloperCenter: "开发者中心",
    dApp: "dApp 信息",
    Tutorials: "教程",
    Documentation: "文档",
    Bounty: "悬赏",
    SmartX: "SmartX",
    Github: "Github",
    Cooperation: "合作",
    CooperateWithOntology: "与本体合作",
    TrustEcosystem: "信任生态",
    Nodes: "节点",
    About: "关于",
    Press: "新闻",
    TechNews: "本体视点",
    Team: "团队",
    AboutOntology: "关于本体",
    WhitePaper: "白皮书",
    Explorer: "区块链浏览器",
    dApps: "dApps",
    dAppsList: "dApps 列表",
    SubmitAdApp: "提交 dApp"
  },
  tooltip: {
    address: {
      ont: "ONT 余额",
      ong: "ONG 余额",
      unboundong:
        "未解绑的 ONG,你可以通过一次本地址的ONT转账将其转化为可提取的ONG",
      claimableong: "可提取的 ONG，你可以通过一次提取操作将其转入ONG 余额",
      oep4:
        "OEP-4 提案是令牌的标准接口，该标准允许在智能合约中实现令牌的标准 API 。 OEP-4 是标准化的令牌。",
      oep5:
        "OEP-5 提案是 NFT 的标准接口，该标准允许在智能合约中实施令牌的标准 API。 NFT 的标准令牌接口允许 ONT 上的令牌方便其他应用程序使用。",
      oep8:
        "OEP-8 提案是 Crypto Item 的标准接口，该标准允许您将差异加密项的任意数量的令牌从一个地址传输到另一个地址。 它结合了 OEP-4 和 OEP-5 的优点，可以非常方便地传输不同类型的 Crypto Item 。",
      orc20: "",
      orc721: "",
      orc1155: ""
    },
    ontid: {
      Type: "本体支持多种加密算法，包括ECDSA，SM2和ED25519。",
      Curve:
        "密钥曲线，例如：P-224，P-256，P-384，P-521，sm2p256v1，SM3withSM2、25519，SHA512withEdDSA",
      Value: "以十六进制字符串展示的所有者公钥",
      PublicKeyId: "所有者公钥"
    },
    block: {
      height: "区块高度",
      time: "区块产生的时间",
      size: "区块的大小，单位：bytes",
      hash: "区块HASH",
      bookkeeper: "记账节点",
      merkle: "此区块中所有交易的Merkle树的根",
      consensus: "共识数据"
    },
    tx: {
      hash: "Transaction Hash",
      time: "交易发生的时间",
      type: "交易类型，包括部署智能合约，调用neovm智能合约，调用wasmvm智能合约",
      txhex: "十六进制字符串表示的序列化交易信息",
      txjson: "以 JSON 格式表示的交易详细信息",
      scevent: "智能合约的执行事件",
      height: "交易所在的区块的高度",
      fee: "交易手续费",
      status: "区块链上的交易状态",
      nonce: "发送方地址发送的交易顺序运行编号，以0为第一宗交易",
      from: "交易的发送方（可能来自合约地址）",
      to: "交易的接收方（可以是合约地址",
      inputData: "自定义数据，把您想要记录的数据写入该交易"
    },
    token: {
      hash: "合约哈希",
      creater: "合约创建者的地址",
      createdTime: "合约创建时间",
      totalSupply: "总供应量",
      decimals: "精度",
      vm_category: "虚拟机类别",
      addressesamount: "当前持有该Token的地址数量。",
      txamount: "请注意：这是每日的累积统计信息，最多有10分钟的统计差异。",
      volume: "请注意：这是每日的累积统计信息，最多有10分钟的统计差异。",
      price: "代币价格"
    },
    contract: {
      hash: "合约哈希",
      creater: "合约创建者的地址",
      createdTime: "合约创建时间",
      addressesamount: "与该合约有过交易的地址数量。",
      txamount: "请注意：这是每日的累积统计信息，最多有10分钟的统计差异。",
      volume: "请注意：这是每日的累积统计信息，最多有10分钟的统计差异。",
      toggleFullscreen: "切换全屏",
      copySourceCode: "复制到剪贴板"
    }
  },
  user: {
    login: "登录",
    use: "使用 ONTO 扫描二维码",
    download: "下载 ONTO"
  },
  error: {
    format: "对不起，无法找到您输入的搜索内容。",
    copied: "复制成功",
    pagesize: "pageSize limit 20",
    searching: "查询中",
    msg1: "请输入通证哈希",
    msg2: "请输入通证名称",
    msg3: "请输入通证ABI",
    msg4: "请输入通证代码",
    msg5: "请输入通证描述",
    msg6: "请输入通证简称",
    msg7: "请输入通证精度",
    msg8: "请输入总发行量",
    msg9: "请上传Logo",
    msg10: "请输入正确格式的邮箱",
    msg11: "请输入联系邮箱",
    msg12: "请输入至少一种通证信息",
    msg13: "请选择虚拟机类别",
    msg14: "请输入{type}通证ID",
    msg15: "请输入{type}通证名称",
    msg16: "请输入{type}总发行量",
    msg17: "请输入{type}通证简称",
    msg18: "{type}通证ID重复",
    msg19: "没有找到您提交的通证哈希",
    msg20: "该通证已提交过",
    msg21: "通证总发行量范围为1-999999999999999"
  },
  exportData: {
    h1: "下载交易记录",
    h2: "在此页面下载交易记录。请在完成人机身份验证后操作。",
    tips: "导出从以下时间点开始的前5000条交易记录",
    timeout: "请选择较小的时间区间，以避免操作超时",
    download: "下载",
    to: "至",
    succ: "下载成功!"
  },
  ...zhLocale
};



// WEBPACK FOOTER //
// ./src/common/lang/zh.js